export const en = {
  login: {
    TITLE: 'Log In',
    EMAIL: { TEXT: 'Email', PLACEHOLDER: 'Email Address' },
    PASSWORD: { TEXT: 'Password', PLACEHOLDER: '**********' },
  },
  strings: {
    RESERVATION_COULD_NOT_BE_CANCELLED:
      'The reservation has already been canceled',
    CREDITS_COULD_NOT_BE_CANCELED: 'The credits has already been canceled',
    CALENDAR_VIEW: 'View Mode',
    LOGOUT_SUCCESS: 'You have successfully logged out',
    HOME: 'Home',
    DASHBOARD: 'Dashboard',
    USERS: 'Users',
    PACKAGES: 'Packages',
    LESSONS: 'Lessons',
    RESERVATIONS: 'Reservations',
    ORDERS: 'Orders',
    WELCOME_USER: 'Welcome {attribute}',
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: 'Are you sure to continue? This action cannot be undone.',
    },
    MODAL: {
      ADD: 'Add {attribute}',
      EDIT: 'Edit {attribute}',
      SEE_INFORMATION: '{attribute} information',
    },
    SOMETHING_WENT_WRONG: 'Oops! Something went wrong',
    CRUD_HELPER: '{attribute} successful',
    SUBTITLE_SUMMARY: 'A summary of your {attribute}',
    SEARCH: 'Search',
    ORDER_BY: 'Order by',
    NOT_AVAILABLE: 'Not available',
  },
  filters: {
    TITLE: 'Filters',
    CREATED_AT: 'Creation Date',
    EMAIL: 'Email',
    COACHES: 'Coaches',
  },
  actions: {
    LOGOUT: 'Logout',
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    ADD: 'Add',
    ACCEPT: 'Accept',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    EXPORT: 'Export',
    IMPORT: 'Import',
    CHOOSE: 'Choose',
    ACTIVATE: 'Activate',
    INACTIVATE: 'Inactivate',
    DETAIL: 'Detail',
    ADDED: 'Added',
    UPDATED: 'Updated',
    DOWNLOADED: 'Downloaded',
    DELETED: 'Deleted',
    SEE_INFO: 'See Information',
  },
  settings: {
    TITLE: 'Settings',
    THEME: 'Theme',
    THEME_MODE: { LIGHT: 'Light', DARK: 'Dark' },
    LANG: 'Language',
  },
  locale: {
    ES: 'Spanish',
    EN: 'English',
  },
  users: {
    MODEL: 'User | Users',
    INDICATOR: 'Indicator',
    PASSWORD: 'Password',
    PASSWORD_CONFIRM: 'Confirm Password',
    PROFILE_IMAGE: 'Profile image',
  },
  reservations: {
    MODEL: 'Reservation | Reservations',
    NO_RESERVATIONS: 'No reservations to display',
  },
  products: {
    MODEL: 'Package | Packages',
    NO_PRODUCTS: 'No packages to display',
  },
  lessons: {
    MODEL: 'Lesson | Lessons',
    TYPE: 'Lesson type',
    BARRÉ: 'Barré',
    LAGREE: 'Lagree',
  },
  orders: {
    MODEL: 'Order | Orders',
    DETAIL: 'Detail of: {attribute}',
  },
  columns: {
    USER: 'User',
    PRODUCT: 'Product',
    NAME: 'Name',
    PRICE: 'Price',
    VALIDITY_DATE: 'Validity until:',
    EXPIRATION: 'Expiration ({attribute})',
    DAY: 'Day | Days',
    DATE_OF_PURCHASE: 'Purchase Date',
    STATUS: 'Status',
    CREATED_AT: 'Creation Date',
    FOLIO: 'Folio',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email',
    ROL: 'Role',
    LESSON_DATE_TIME: 'Lesson Date and Time',
    DURATION: 'Duration ({attribute})',
    MINUTE: 'Minute | Minutes',
    TITLE: 'Title',
    SPOTS: 'Spots',
    COACH: 'Coach',
    CREDITS_AMOUNT: 'Credits',
    DESCRIPTION: 'Description',
    SPOT: 'Spot',
    LESSON: 'Lesson',
    SHOE_SIZE: 'Shoe Size',
    EXPIRATION_AT: 'Expiration at',
    GIFTED_BY: 'Gifted by:',
    GIFTED_AT: 'Gifted at:',
    IS_UNLIMITED: 'Is unlimited',
    IS_UNIQUE_PROMO: 'Is unique promo',
  },
  calendar: {
    DAILY: 'Daily',
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
  },
  status: {
    ACTIVE: 'Active',
    DELETED: 'Deleted',
    INACTIVE: 'Inactive',
    REQUESTED: 'In process',
    PENDING: 'Pending',
    DONE: 'Completed',
    CANCELED: 'Canceled',
  },
  validation: {
    ACCEPTED: 'The {attribute} must be accepted.',
    ACCEPTED_IF: 'The {attribute} must be accepted when {other} is {value}.',
    ACTIVE_URL: 'The {attribute} is not a valid URL.',
    AFTER: 'The {attribute} must be a date after {date}.',
    AFTER_OR_EQUAL: 'The {attribute} must be a date after or equal to {date}.',
    ALPHA: 'The {attribute} must only contain letters.',
    ALPHA_DASH:
      'The {attribute} must only contain letters, numbers, dashes and underscores.',
    ALPHA_NUM: 'The {attribute} must only contain letters and numbers.',
    ARRAY: 'The {attribute} must be an array.',
    BEFORE: 'The {attribute} must be a date before {date}.',
    BEFORE_OR_EQUAL:
      'The {attribute} must be a date before or equal to {date}.',
    BETWEEN: {
      NUMERIC: 'The {attribute} must be between {min} and {max}.',
      FILE: 'The {attribute} must be between {min} and {max} kilobytes.',
      STRING: 'The {attribute} must be between {min} and {max} characters.',
      ARRAY: 'The {attribute} must have between {min} and {max} items.',
    },
    BOOLEAN: 'The {attribute} field must be true or false.',
    CONFIRMED: 'The {attribute} confirmation does not match.',
    CURRENT_PASSWORD: 'The password is incorrect.',
    DATE: 'The {attribute} is not a valid date.',
    DATE_EQUALS: 'The {attribute} must be a date equal to {date}.',
    DATE_FORMAT: 'The {attribute} does not match the format {format}.',
    DECLINED: 'The {attribute} must be declined.',
    DECLINED_IF: 'The {attribute} must be declined when {other} is {value}.',
    DIFFERENT: 'The {attribute} and {other} must be different.',
    DIGITS: 'The {attribute} must be {digits} digits.',
    DIGITS_BETWEEN: 'The {attribute} must be between {min} and {max} digits.',
    DIMENSIONS: 'The {attribute} has invalid image dimensions.',
    DISTINCT: 'The {attribute} field has a duplicate value.',
    EMAIL: 'The {attribute} must be a valid email address.',
    ENDS_WITH: 'The {attribute} must end with one of the following: {values}.',
    ENUM: 'The selected {attribute} is invalid.',
    EXISTS: 'The selected {attribute} is invalid.',
    FILE: 'The {attribute} must be a file.',
    FILLED: 'The {attribute} field must have a value.',
    GT: {
      NUMERIC: 'The {attribute} must be greater than {value}.',
      FILE: 'The {attribute} must be greater than {value} kilobytes.',
      STRING: 'The {attribute} must be greater than {value} characters.',
      ARRAY: 'The {attribute} must have more than {value} items.',
    },
    GTE: {
      NUMERIC: 'The {attribute} must be greater than or equal to {value}.',
      FILE: 'The {attribute} must be greater than or equal to {value} kilobytes.',
      STRING:
        'The {attribute} must be greater than or equal to {value} characters.',
      ARRAY: 'The {attribute} must have {value} items or more.',
    },
    IMAGE: 'The {attribute} must be an image.',
    IN: 'The selected {attribute} is invalid.',
    IN_ARRAY: 'The {attribute} field does not exist in {other}.',
    INTEGER: 'The {attribute} must be an integer.',
    IP: 'The {attribute} must be a valid IP address.',
    IPV4: 'The {attribute} must be a valid IPv4 address.',
    IPV6: 'The {attribute} must be a valid IPv6 address.',
    JSON: 'The {attribute} must be a valid JSON string.',
    LT: {
      NUMERIC: 'The {attribute} must be less than {value}.',
      FILE: 'The {attribute} must be less than {value} kilobytes.',
      STRING: 'The {attribute} must be less than {value} characters.',
      ARRAY: 'The {attribute} must have less than {value} items.',
    },
    LTE: {
      NUMERIC: 'The {attribute} must be less than or equal to {value}.',
      FILE: 'The {attribute} must be less than or equal to {value} kilobytes.',
      STRING:
        'The {attribute} must be less than or equal to {value} characters.',
      ARRAY: 'The {attribute} must not have more than {value} items.',
    },
    MAC_ADDRESS: 'The {attribute} must be a valid MAC address.',
    MAX: {
      NUMERIC: 'The {attribute} must not be greater than {max}.',
      FILE: 'The {attribute} must not be greater than {max} kilobytes.',
      STRING: 'The {attribute} must not be greater than {max} characters.',
      ARRAY: 'The {attribute} must not have more than {max} items.',
    },
    MIMES: 'The {attribute} must be a file of type: {values}.',
    MIMETYPES: 'The {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'The {attribute} must be at least {min}.',
      FILE: 'The {attribute} must be at least {min} kilobytes.',
      STRING: 'The {attribute} must be at least {min} characters.',
      ARRAY: 'The {attribute} must have at least {min} items.',
    },
    MULTIPLE_OF: 'The {attribute} must be a multiple of {value}.',
    NOT_IN: 'The selected {attribute} is invalid.',
    NOT_REGEX: 'The {attribute} format is invalid.',
    NUMERIC: 'The {attribute} must be a number.',
    PASSWORD: 'The password is incorrect.',
    PRESENT: 'The {attribute} field must be present.',
    PROHIBITED: 'The {attribute} field is prohibited.',
    PROHIBITED_IF:
      'The {attribute} field is prohibited when {other} is {value}.',
    PROHIBITED_UNLESS:
      'The {attribute} field is prohibited unless {other} is in {values}.',
    PROHIBITS: 'The {attribute} field prohibits {other} from being present.',
    REGEX: 'The {attribute} format is invalid.',
    REQUIRED: 'The {attribute} field is required.',
    REQUIRED_ARRAY_KEYS:
      'The {attribute} field must contain entries for: {values}.',
    REQUIRED_IF: 'The {attribute} field is required when {other} is {value}.',
    REQUIRED_UNLESS:
      'The {attribute} field is required unless {other} is in {values}.',
    REQUIRED_WITH:
      'The {attribute} field is required when {values} is present.',
    REQUIRED_WITH_ALL:
      'The {attribute} field is required when {values} are present.',
    REQUIRED_WITHOUT:
      'The {attribute} field is required when {values} is not present.',
    REQUIRED_WITHOUT_ALL:
      'The {attribute} field is required when none of {values} are present.',
    SAME: 'The {attribute} and {other} must match.',
    SIZE: {
      NUMERIC: 'The {attribute} must be {size}.',
      FILE: 'The {attribute} must be {size} kilobytes.',
      STRING: 'The {attribute} must be {size} characters.',
      ARRAY: 'The {attribute} must contain {size} items.',
    },
    STARTS_WITH:
      'The {attribute} must start with one of the following: {values}.',
    STRING: 'The {attribute} must be a string.',
    TIMEZONE: 'The {attribute} must be a valid timezone.',
    UNIQUE: 'The {attribute} has already been taken.',
    UPLOADED: 'The {attribute} failed to upload.',
    URL: 'The {attribute} must be a valid URL.',
    UUID: 'The {attribute} must be a valid UUID.',
    PASSWORD_EQUALS: 'Passwords should be equals.',
    ATTRIBUTES: {},
  },
}
